import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import { Button } from "@qgiv/core-donor";
import * as formViews from "./constants/formViews";

const ResetPasswordConfirmation = ({
    donorActionUrl,
    initialGlobalAccountAction,
    updateRegistrationAccountFormView,
    updateRegistrationAccountSubmitted,
}) => {
    const dispatch = useDispatch();
    const {
        ENUMS: { GlobalAccountAction },
    } = constants;

    const handleOkayThanksClick = () => {
        const isAlreadyOnValidLoginURL =
            initialGlobalAccountAction === GlobalAccountAction.SIGN_IN;

        if (isAlreadyOnValidLoginURL) {
            const emptySubmittedValues = {};
            // If the user was originally taken to the log in screen, reset the
            // data that was used with the form submission in state so that
            // they can be taken back to the log in screen without reloading
            // the webpage
            dispatch(updateRegistrationAccountSubmitted(emptySubmittedValues));
            dispatch(updateRegistrationAccountFormView(formViews.SIGN_IN));
        } else {
            // Redirect the user to their login page
            window.location.href = donorActionUrl;
        }
    };

    return (
        <div className="grid">
            <div className="col col--12">
                <Button onClick={handleOkayThanksClick} type="button">
                    Okay, thanks!
                </Button>
            </div>
        </div>
    );
};

ResetPasswordConfirmation.propTypes = {
    donorActionUrl: PropTypes.string.isRequired,
    initialGlobalAccountAction: PropTypes.number.isRequired,
    updateRegistrationAccountFormView: PropTypes.func.isRequired,
    updateRegistrationAccountSubmitted: PropTypes.func.isRequired,
};

export default ResetPasswordConfirmation;
